import React, { Suspense, lazy } from 'react';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, ThemeProvider, Typography } from '@mui/material';
import ErrorBoundary from './ErrorBoundary';
import Wrapper from './Wrapper';
import theme from './theme';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const PodcastPage = lazy(() => import('./pages/PodcastPage'));
const CheckoutPage = lazy(() => import('./pages/donate/CheckoutPage'));
const ReturnPage = lazy(() => import('./pages/donate/ReturnPage'));
const DonatePage = lazy(() => import('./pages/donate/DonatePage'));
const DonateWrapper = lazy(() => import('./pages/donate/Wrapper'));

const client = new ApolloClient({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
});

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ApolloProvider client={client}>
          <BrowserRouter>
            <Wrapper>
              <Suspense fallback={<Typography>Loading...</Typography>}>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/podcast" element={<PodcastPage />} />

                  {/* This is a "Layout Route" to wrap all child routes inside the DonateWrapper component */}
                  {/* See docs: https://reactrouter.com/start/declarative/routing#layout-routes */}
                  <Route element={<DonateWrapper />}>
                    <Route path="/donate" element={<DonatePage />} />
                    <Route path="/donate/checkout" element={<CheckoutPage />} />
                    <Route path="/donate/return" element={<ReturnPage />} />
                  </Route>
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </Suspense>
            </Wrapper>
          </BrowserRouter>
        </ApolloProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
